import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from 'apollo-boost';
import { checkToken } from '@app/auth/firebase';
const httpLinkOptions: HttpLink.Options = {
  uri: process.env.REACT_APP_HTTP_BASEURL,
  credentials: 'same-origin',
};
const httpLink = new HttpLink(httpLinkOptions);
const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('token');
  if (token) {
    checkToken(token);
  }
  operation.setContext({
    headers: {
      authorization: token || '',
    },
  });

  return forward(operation);
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({ addTypename: false }),
});
